import React, { Component } from 'react';

import qs from 'querystring';
import PropTypes from 'prop-types';

// Components
import ResultsVisualization from '../resultsvisualization';

class PollVisualization extends Component {
	static findActivePoll(polls) {
		const sorted = polls.sort((a, b) => {
			if (a.triggeredAt) {
				return new Date(b.triggeredAt) - new Date(a.triggeredAt);
			}
			return 1;
		});
		return sorted[0];
	}

	static decideActivePoll(polls) {
		let activePoll;
		const { pollId } = qs.parse(window.document.location.search.substring(1));
		if (pollId) {
			activePoll = polls.find(poll => poll.id === pollId);
		}
		if (!activePoll) {
			activePoll = PollVisualization.findActivePoll(polls);
		}
		return activePoll;
	}


	constructor(props) {
		super(props);
		this.state = {
			activePoll: PollVisualization.decideActivePoll(props.polls),
			showResults: false,
		};
	}

	componentWillReceiveProps(nextProps) {
		const oldPoll = PollVisualization.decideActivePoll(this.props.polls);
		const activePoll = PollVisualization.decideActivePoll(nextProps.polls);
		const pollChanged = (oldPoll || {}).id !== (activePoll || {}).id;
		const timestampsPresent = (oldPoll || {}).animateStudioResults || (activePoll || {}).animateStudioResults;
		const timestampChanged = timestampsPresent ? (oldPoll || {}).animateStudioResults !== (activePoll || {}).animateStudioResults : false;
		const animateTimestampChanged = (!pollChanged && timestampChanged);
		const showResultsWhenPollChanged = ((pollChanged) ? false : this.state.showResults);
		/* eslint-disable-next-line react/no-access-state-in-setstate */
		const showResults = (!pollChanged && animateTimestampChanged) ? this.state.showResults === false : showResultsWhenPollChanged;
		this.setState({ activePoll, showResults });
	}

	render() {
		const {
			isLoading,
			status,
			enabled,
			polls,
			results,
			pollStatus,
			isVisible,
			locale,
			config,
			theming,
			...props
		} = this.props;

		// Loading
		if (isLoading && (status !== 'initialized')) {
			return null;
		}

		// Loaded, but crashed
		if (status === 'failed') {
			return (
				<div />
			);
		}

		// Loaded, but disabled
		if (!enabled) {
			return null;
		}

		// get active studio poll
		const { activePoll } = this.state;

		// Loaded and enabled, but no poll
		if (activePoll) {
			const liveResults = results[activePoll.id] || {};
			const counters = liveResults.counters || {};

			// Prep choices
			const choicesWithResults = activePoll.answer.choices
				// Inject result onto it
				.map((choice, idx) => ({
					...choice,
					idx,
					numVotes: counters[choice.id] || 0,
				}));

			// Image set? Set it as background
			const wrapperStyles = {};
			if ((activePoll.studio || {}).backgroundImage) {
				wrapperStyles.background = `transparent url(${activePoll.studio.backgroundImage.url}) no-repeat 50% 50% / cover`;
			}

			return (
				<div style={{
					height: '100%',
					width: '100%',
				}}
				>
					<ResultsVisualization
						questionText={activePoll.question.text}
						locale={locale}
						theming={theming}
						choices={choicesWithResults}
						backgroundUrl={(activePoll.studio || {}).backgroundImage ? activePoll.studio.backgroundImage.url : undefined}
						showResults={this.state.showResults}
						background={activePoll.studio}
					/>
				</div>
			);
		}

		return (
			<div>
				<p>{locale['polls.nopoll.message'] || ''}</p>
			</div>
		);
	}
}

PollVisualization.propTypes = {
	enabled: PropTypes.bool.isRequired,
	isLoading: PropTypes.bool.isRequired,
	status: PropTypes.string.isRequired,
	polls: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
	results: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	pollStatus: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	isVisible: PropTypes.bool.isRequired,
	locale: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	config: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	theming: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

PollVisualization.defaultProps = {};

export default PollVisualization;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/pollvisualization/PollVisualization.component.js